export default __webpack_public_path__ + "static/media/enable-cam-safari-ios-2.b803a47b.png";